import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class Reports extends Base {
	constructor(props) {
		super(props);
		this.state = {
			data: null,
			loading: true
		}
	}
	componentDidMount() {
		this.httpPost("api/v1/common/get")
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.setState({
						data: data,
						loading: false
					})
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	setFavReport(e) {

	}
	renderForm() {
		return <div className="container">
			<div className="center-block">
				<p className="acc-page-top-help-box">
					<span className="fa fa-info-circle fa-2x" style={{ "color": "#2ab27b" }}></span>&nbsp;&nbsp;
					<span>توجه: برای افزودن یک گزارش به لیست مورد علاقه، بر روی ستاره کنار نام گزارش کلیک کنید. لینک گزارش های ستاره دار در منوی گزارشات در بالا و در پنل گزارشات در داشبورد برای دسترسی سریعتر قرار می گیرد.</span>
				</p>
				<div className="row">
					<div className="col-sm-6">
						<div className="panel panel-info pd-10">
							<h5 className="iransans txt-bold">مالی</h5>
							<div className="list-group">
								<div className="list-group-item list-group-item-acc1">
									<span onClick={e => this.setFavReport('[7]')} className={"fa mr-l-5 fa-star " + (this.state.data.global.user.favMenu.includes('[7]') ? "fullFavStar" : "emptyFavStar")}></span>
									<NavLink to="/report/balance/" style={{ "color": "black" }}> ترازنامه</NavLink>
								</div>
								<div className="list-group-item list-group-item-acc1">
									<span onClick={e => this.setFavReport('[8]')} className={"fa mr-l-5 fa-star " + (this.state.data.global.user.favMenu.includes('[8]') ? "fullFavStar" : "emptyFavStar")}></span>
									<NavLink to="/report/income/" style={{ "color": "black" }}>صورت سود و زیان</NavLink>
								</div>
								<div className="list-group-item list-group-item-acc1">
									<span onClick={e => this.setFavReport('[9]')} className={"fa mr-l-5 fa-star " + (this.state.data.global.user.favMenu.includes('[9]') ? "fullFavStar" : "emptyFavStar")}></span>
									<NavLink to="/report/capital/" style={{ "color": "black" }}>صورت حساب سرمایه</NavLink>
								</div>
							</div>
						</div>
						<div className="panel panel-info pd-10">
							<h5 className="iransans txt-bold">حسابداری</h5>
							<div className="list-group">
								<div className="list-group-item list-group-item-acc1">
									<span onClick={e => this.setFavReport('[10]')} className={"fa mr-l-5 fa-star " + (this.state.data.global.user.favMenu.includes('[10]') ? "fullFavStar" : "emptyFavStar")}></span>
									<NavLink to="/report/journal/" style={{ "color": "black" }}>دفتر روزنامه</NavLink>
								</div>
								<div className="list-group-item list-group-item-acc1">
									<span onClick={e => this.setFavReport('[11]')} className={"fa mr-l-5 fa-star " + (this.state.data.global.user.favMenu.includes('[11]') ? "fullFavStar" : "emptyFavStar")}></span>
									<NavLink to="/report/ledger/" style={{ "color": "black" }}>دفتر گروه،کل و معین</NavLink>
								</div>
								<div className="list-group-item list-group-item-acc1">
									<span onClick={e => this.setFavReport('[12]')} className={"fa mr-l-5 fa-star " + (this.state.data.global.user.favMenu.includes('[12]') ? "fullFavStar" : "emptyFavStar")}></span>
									<NavLink to="/report/trialbalance/" style={{ "color": "black" }}>تراز آزمایشی</NavLink>
								</div>
								<div className="list-group-item list-group-item-acc1">
									<span onClick={e => this.setFavReport('[13]')} className={"fa mr-l-5 fa-star " + (this.state.data.global.user.favMenu.includes('[13]') ? "fullFavStar" : "emptyFavStar")}></span>
									<NavLink to="/report/explore/" style={{ "color": "black" }}>مرورحسابها</NavLink>
								</div>
							</div>
						</div>
						<div className="panel panel-info pd-10">
							<h5 className="iransans txt-bold">اشخاص</h5>
							<div className="list-group">
								<div className="list-group-item list-group-item-acc1">
									<span onClick={e => this.setFavReport('[14]')} className={"fa mr-l-5 fa-star " + (this.state.data.global.user.favMenu.includes('[14]') ? "fullFavStar" : "emptyFavStar")}></span>
									<NavLink to="/report/debcred/" style={{ "color": "black" }}>بدهکاران و بستانکاران</NavLink>
								</div>
							</div>
						</div>
					</div>
					<div className="col-sm-6">
						{this.state.module_warehouse &&
							<div className="panel panel-info pd-10">
								<h5 className="iransans txt-bold">انبار</h5>
								<div className="list-group">
									<div className="list-group-item list-group-item-acc1">
										<span onClick={e => this.setFavReport('[1]')} className={"fa mr-l-5 fa-star " + (this.state.data.global.user.favMenu.includes('[1]') ? "fullFavStar" : "emptyFavStar")}></span>
										<NavLink to="/report/warehouseio/" onClick="showReportWarehouseIO()" style={{ "color": "black" }}>ورود و خروج کالا</NavLink>
									</div>
									<div className="list-group-item list-group-item-acc1">
										<span onClick={e => this.setFavReport('[2]')} className={"fa mr-l-5 fa-star " + (this.state.data.global.user.favMenu.includes('[2]') ? "fullFavStar" : "emptyFavStar")}></span>
										<NavLink to="/report/inventory/" style={{ "color": "black" }}>موجودی انبار کالا</NavLink>
									</div>
								</div>
							</div>
						}
						<div className="panel panel-info pd-10">
							<h5 className="iransans txt-bold">سایر</h5>
							<div className="list-group">
								<div className="list-group-item list-group-item-acc1">
									<span onClick={e => this.setFavReport('[4]')} className={"fa mr-l-5 fa-star " + (this.state.data.global.user.favMenu.includes('[4]') ? "fullFavStar" : "emptyFavStar")}></span>
									<NavLink to="/report/banktransaction/" style={{ "color": "black" }}>گردش حساب بانک</NavLink>
								</div>
								<div className="list-group-item list-group-item-acc1">
									<span onClick={e => this.setFavReport('[5]')} className={"fa mr-l-5 fa-star " + (this.state.data.global.user.favMenu.includes('[5]') ? "fullFavStar" : "emptyFavStar")}></span>
									<NavLink to="/report/cashtransaction/" style={{ "color": "black" }}>گردش حساب صندوق</NavLink>
								</div>
								<div className="list-group-item list-group-item-acc1">
									<span onClick={e => this.setFavReport('[6]')} className={"fa mr-l-5 fa-star " + (this.state.data.global.user.favMenu.includes('[6]') ? "fullFavStar" : "emptyFavStar")}></span>
									<NavLink to="/report/userlog/" style={{ "color": "black" }}>لاگ کاربران</NavLink>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				<Header data={this.state.data} />,
				this.renderForm(),
				<Footer />
			];

		return contents;
	}
}